import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { UnexpectedError } from '../error-pages/UnexpectedError';

const GlobalErrorHandler: React.FC = ({ children }) => {
  return <ErrorBoundary fallback={<UnexpectedError />}>{children}</ErrorBoundary>;
};

export default GlobalErrorHandler;
